import React from 'react';
import Footer from 'src/components/Footer';
import Header from '../../components/Header';
import AppRoutes from 'src/routes';
import styled from 'styled-components';
import { MessageBanner } from 'src/components/GlobalMessageBanner';

const PageLayout = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: flex-start;
`;

const BodyLayout = () => {
  return (
    <>
      <MessageBanner />
      <AppRoutes />
    </>
  );
};
export class AppLayout extends React.Component {
  render() {
    return (
      <PageLayout>
        <Header />
        <BodyLayout />
        <Footer />
      </PageLayout>
    );
  }
}

export default AppLayout;
